import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
    fetchVehicleTemplates,
    fetchVehicleTemplateById,
    createVehicleTemplate,
    updateVehicleTemplate,
    deleteVehicleTemplate,
    selectTemplate,
    clearSelectedTemplate,
    clearTemplatesError,
    selectAllTemplates,
    selectSelectedTemplate,
    selectTemplatesLoading,
    selectTemplatesError,
} from '../store/slices/vehicleTemplatesSlice';
import type { CreateVehicleTemplateDto, UpdateVehicleTemplateDto } from '../types/model/vehicle-template.model';

export const useVehicleTemplates = () => {
    const dispatch = useAppDispatch();

    // Selectores
    const templates = useAppSelector(selectAllTemplates);
    const selectedTemplate = useAppSelector(selectSelectedTemplate);
    const isLoading = useAppSelector(selectTemplatesLoading);
    const error = useAppSelector(selectTemplatesError);

    // Acciones asíncronas
    const loadTemplates = useCallback(() => {
        return dispatch(fetchVehicleTemplates());
    }, [dispatch]);

    const loadTemplateById = useCallback((id: string) => {
        return dispatch(fetchVehicleTemplateById(id));
    }, [dispatch]);

    const addTemplate = useCallback((data: CreateVehicleTemplateDto) => {
        return dispatch(createVehicleTemplate(data));
    }, [dispatch]);

    const editTemplate = useCallback((id: string, data: UpdateVehicleTemplateDto) => {
        return dispatch(updateVehicleTemplate({ id, data }));
    }, [dispatch]);

    const removeTemplate = useCallback((id: string) => {
        return dispatch(deleteVehicleTemplate(id));
    }, [dispatch]);

    // Acciones síncronas
    const selectTemplateById = useCallback((id: string) => {
        const template = templates.find((t) => t.id === id);
        if (template) {
            dispatch(selectTemplate(template));
        }
    }, [dispatch, templates]);

    const clearSelection = useCallback(() => {
        dispatch(clearSelectedTemplate());
    }, [dispatch]);

    const clearError = useCallback(() => {
        dispatch(clearTemplatesError());
    }, [dispatch]);

    return {
        // Estado
        templates,
        selectedTemplate,
        isLoading,
        error,

        // Acciones
        loadTemplates,
        loadTemplateById,
        addTemplate,
        editTemplate,
        removeTemplate,
        selectTemplateById,
        clearSelection,
        clearError,
    };
};
